import React from 'react';
import ExperimentContext from './context';

const createExperimentHook = <A>(
  id: string,
  baseline: A,
  variants: { [key: string]: A }
) => {
  if (
    typeof id === 'undefined' ||
    typeof baseline === 'undefined' ||
    typeof variants === 'undefined'
  ) {
    throw new Error(
      'createExperimentHook expects 3 arguments: id, baseline, variants'
    );
  }
  return () => {
    const { selectedVariants, registerExperiment } = React.useContext(
      ExperimentContext
    );

    React.useEffect(() => {
      if (registerExperiment) {
        registerExperiment({
          id,
          baseline,
          variants,
        });
      }
    }, [registerExperiment]);

    const variantName =
      selectedVariants &&
      selectedVariants[id] &&
      selectedVariants[id].selectedVariant;

    return (variantName && variants[variantName]) || baseline;
  };
};

export default createExperimentHook;
